"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommunityChannelsHistory = useCommunityChannelsHistory;
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _streamChatReact = require("stream-chat-react");
var _utils = require("../../../utils");
var _lodash = require("lodash");
var _utils2 = require("./utils");
function useCommunityChannelsHistory(setMenuOpen, baseUrl, client) {
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    channel = _useChatContext.channel,
    setActiveChannel = _useChatContext.setActiveChannel;
  var history = (0, _reactRouterDom.useHistory)();
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    pathname = _useLocation.pathname;
  var channelIdFromPath = (0, _react.useMemo)(function () {
    return (0, _utils2.getChannelIdFromPath)(baseUrl, pathname);
  }, [baseUrl, pathname]);

  // This one hanldles the static channels logic
  (0, _react.useEffect)(function () {
    // Checking for the data that we need to proceed
    if (!client) {
      return;
    }
    // We only need to take action and parse/set channel if we're not in baseUrl,
    // which is community initial pathname by default
    if (pathname === baseUrl) {
      // If we're in mobile, we show channels list, otherwise  need to replace the baseUrl with full string containing
      // channel ID, for it to work correctly with browser back-forward buttons on desktop
      if ((0, _utils.isMobileOrTablet)()) {
        // Open channel list in mobile
        setMenuOpen(true);
      } else if (channel) {
        history.replace("".concat(baseUrl, "/").concat(channel === null || channel === void 0 ? void 0 : channel.id));
      }
    } else {
      // General case where we parse pathname string and set corresponding channel
      var channelToSet = (0, _lodash.find)(client.activeChannels, function (_ref) {
        var id = _ref.id;
        return id === channelIdFromPath;
      });
      // If no channel found by id from path, it will be handled by the early return condition above (no channel)
      // since it will set activeChannelId to non-existing one, which is similar to setting it to null
      if (channelToSet) {
        setActiveChannel(channelToSet);
        // Additionally, we need to close channels list on mobile
        if ((0, _utils.isMobileOrTablet)()) {
          setMenuOpen(false);
        }
      }
    }
  }, [pathname, client, channel]);

  // Set the URL back on mobile after going back to channel list and reset static channel
  var handleMobileChannelClose = function handleMobileChannelClose() {
    if ((0, _utils.isMobileOrTablet)()) {
      history.push(baseUrl);
    }
  };
  return {
    handleMobileChannelClose: handleMobileChannelClose
  };
}